export default {"src":"/_next/static/media/facebook-f-brands.c4c8e6ea.svg","height":512,"width":320};